<template>
  <ECharts :autoresize="true" :options="options"></ECharts>
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts.vue';
import 'echarts/lib/chart/bar';
// import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/markLine';
import 'echarts/lib/component/markPoint';

export default {
  components: {
    ECharts,
  },
  data() {
    return {
      options: {},
    };
  },
  props: {
    hdata: {
      type: Object || Array,
      default: () => ({}),
    },
    title: {
      type: String,
      default: '',
    },
  },
  watch: {
    hdata() {
      if (this.hdata) {
        this.getInit();
      }
    },
  },
  created() {
    this.getInit();
  },
  methods: {
    // 获取X轴Y轴的数据
    getInit() {
      const data = [];
      data.push(this.hdata && this.hdata.Total ? this.hdata.Total : 0);
      data.push(this.hdata && this.hdata.Deal ? this.hdata.Deal : 0);
      // data.push(this.hdata && this.hdata.Edit ? this.hdata.Edit : 0);
      data.push(this.hdata && this.hdata.Finish ? this.hdata.Finish : 0);

      const opt = {
        title: {
          text: this.title,
          top: 10,
          left: 30,
          textStyle: {
            fontWeight: 'normal',
            fontSize: 16,
          },
        },
        tooltip: {
          trigger: 'item',
        },
        grid: { right: '30px', left: '30px', bottom: '40px' },
        calculable: true,
        xAxis: [
          // { data: ['总报警', '待处理', '编辑中', '已办结'] },
          { data: ['总报警', '未关闭',  '已关闭'] },
          { axisTick: { show: false } },
          { splitLine: { show: false } },
          {
            axisLabel: {
              interval: 0,
              rotate: 40,
            },
          },
        ],
        yAxis: [
          { axisTick: { show: false } },
          { splitLine: { show: false } },
          { axisLabel: { show: false } },
        ],
        series: [
          {
            type: 'bar',
            barWidth: '25%',
            data,
            itemStyle: {
              normal: {
                // 设置柱状颜色
                color(params) {
                  // const colorList = ['#D52C57', '#15BC84', '#FE943E', '#39AEF1'];
                  const colorList = [ '#39AEF1', '#D52C57', '#15BC84'];
                  return colorList[params.dataIndex];
                },
                label: { show: true, position: 'top' },
              },
              // 鼠标悬停时：
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      };
      this.options = opt;
    },
  },
};
</script>

<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}
</style>
